import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Users, Clock, AlertTriangle, ArrowRight, Wallet } from 'lucide-react';
import api from '../../api/client';

const MESI_FULL = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
                   'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

export default function RiepilogoMensile() {
  const navigate = useNavigate();
  const oggi = new Date();
  const [anno, setAnno] = useState(oggi.getFullYear());
  const [mese, setMese] = useState(oggi.getMonth() + 1);
  const [righe, setRighe] = useState([]);
  const [loading, setLoading] = useState(true);

  const navMese = (dir) => {
    let m = mese + dir, a = anno;
    if (m > 12) { m = 1; a++; }
    if (m < 1)  { m = 12; a--; }
    setMese(m); setAnno(a);
  };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get(`/dipendenti/riepilogo/${anno}/${mese}`);
      setRighe(r.data);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [anno, mese]);

  useEffect(() => { load(); }, [load]);

  const totOre     = righe.reduce((s, r) => s + r.ore_totali, 0);
  const totImporto = righe.reduce((s, r) => s + r.importo_totale, 0);
  const totDaConf  = righe.reduce((s, r) => s + r.da_confermare, 0);
  const totDaApprovare = righe.reduce((s, r) => s + (r.da_approvare || 0), 0);

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'24px' }}>
        <div>
          <h1 style={s.title}>RIEPILOGO MENSILE PRESENZE</h1>
          <p style={s.sub}>Ore e compensi per dipendente, per mese — sola lettura</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
          <button style={s.linkCalendario} onClick={() => navigate('/dipendenti/paghe')}>
            <Wallet size={13}/> PAGHE MENSILI
          </button>
          <button style={s.navBtn} onClick={() => navMese(-1)}><ChevronLeft size={16}/></button>
          <span style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-xl)', fontWeight:'800', minWidth:'160px', textAlign:'center' }}>
            {MESI_FULL[mese-1].toUpperCase()} {anno}
          </span>
          <button style={s.navBtn} onClick={() => navMese(1)}><ChevronRight size={16}/></button>
        </div>
      </div>

      {/* KPI mese */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'12px', marginBottom:'24px' }}>
        <div style={s.kpi}>
          <div style={s.kpiLabel}>DIPENDENTI CON PRESENZE</div>
          <div style={s.kpiVal}>{righe.length}</div>
        </div>
        <div style={s.kpi}>
          <div style={s.kpiLabel}>ORE TOTALI</div>
          <div style={{ ...s.kpiVal, color:'#F4600C' }}>{totOre.toFixed(2)}</div>
        </div>
        <div style={s.kpi}>
          <div style={s.kpiLabel}>COMPENSI TOTALI</div>
          <div style={{ ...s.kpiVal, color:'#F59E0B' }}>€{totImporto.toFixed(2)}</div>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:'60px', color:'#555' }}>Caricamento...</div>
      ) : righe.length === 0 ? (
        <div style={{ textAlign:'center', padding:'60px', color:'#555' }}>
          <Users size={40} color="var(--text-dim)" style={{ marginBottom:'12px' }}/>
          <p>Nessuna presenza registrata in {MESI_FULL[mese-1].toLowerCase()} {anno}.</p>
        </div>
      ) : (
        <div style={{ background:'var(--bg-card,#141414)', border:'1px solid var(--border,#1E1E1E)', borderRadius:'12px', overflow:'hidden' }}>
          <div style={s.rowHead}>
            <div style={{ flex:1 }}>DIPENDENTE</div>
            <div style={{ width:'110px', textAlign:'right' }}>PRESENZE</div>
            <div style={{ width:'110px', textAlign:'right' }}>ORE</div>
            <div style={{ width:'170px', textAlign:'right' }}>COMPENSO</div>
            <div style={{ width:'130px', textAlign:'right' }}>DA CONFERMARE</div>
            <div style={{ width:'130px', textAlign:'right' }}>DA APPROVARE</div>
          </div>
          {righe.map(r => (
            <div key={r.dipendente.id} style={s.row}
              onClick={() => navigate(`/dipendenti/${r.dipendente.id}`)}
              onMouseEnter={e=>e.currentTarget.style.background='var(--bg-input)'}
              onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontWeight:'700', fontSize: 'var(--font-size-sm)' }}>{r.dipendente.cognome} {r.dipendente.nome}</div>
                <div style={{ fontSize: 'var(--font-size-xs)', color:'#555' }}>{r.dipendente.ruolo_descrizione}</div>
              </div>
              <div style={{ width:'110px', textAlign:'right', fontSize: 'var(--font-size-sm)' }}>{r.n_presenze}</div>
              <div style={{ width:'110px', textAlign:'right', fontSize: 'var(--font-size-sm)' }}>{r.ore_totali.toFixed(2)}</div>
              <div style={{ width:'170px', textAlign:'right' }} onClick={e => e.stopPropagation()}>
                <div style={{ display:'flex', alignItems:'center', gap:'6px', justifyContent:'flex-end' }}>
                  <span style={{ fontWeight:'700', fontSize: 'var(--font-size-sm)' }}>€{r.importo_totale.toFixed(2)}</span>
                  {(r.dipendente.modalita_compenso === 'FISSO' || r.dipendente.modalita_compenso === 'FISSO_ORE') && !r.paga_inserita && (
                    <span style={{ fontSize: 'var(--font-size-xs)', color:'#F59E0B' }} title="Mensilità non ancora inserita in Paghe Mensili">
                      da inserire
                    </span>
                  )}
                </div>
              </div>
              <div style={{ width:'130px', textAlign:'right' }}>
                {r.da_confermare > 0 ? (
                  <span style={s.badgeWarn}><AlertTriangle size={11}/> {r.da_confermare}</span>
                ) : (
                  <span style={{ color:'var(--text-dim)', fontSize: 'var(--font-size-xs)' }}>—</span>
                )}
              </div>
              <div style={{ width:'130px', textAlign:'right' }}>
                {r.da_approvare > 0 ? (
                  <span style={s.badgeApprova}><Clock size={11}/> {r.da_approvare}</span>
                ) : (
                  <span style={{ color:'var(--text-dim)', fontSize: 'var(--font-size-xs)' }}>—</span>
                )}
              </div>
            </div>
          ))}
          {(totDaConf > 0 || totDaApprovare > 0) && (
            <div style={{ padding:'10px 20px', borderTop:'1px solid var(--border,#1E1E1E)', display:'flex', flexDirection:'column', gap:'4px' }}>
              {totDaConf > 0 && (
                <div style={{ fontSize: 'var(--font-size-xs)', color:'#F59E0B', display:'flex', alignItems:'center', gap:'6px' }}>
                  <AlertTriangle size={12}/> {totDaConf} presenze inserite da voi, ancora da confermare da parte dell'allenatore.
                </div>
              )}
              {totDaApprovare > 0 && (
                <div style={{ fontSize: 'var(--font-size-xs)', color:'#8B5CF6', display:'flex', alignItems:'center', gap:'6px', justifyContent:'space-between' }}>
                  <span style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                    <Clock size={12}/> {totDaApprovare} allenamenti auto-segnalati dagli allenatori, in attesa di una vostra approvazione — non ancora conteggiati.
                  </span>
                  <button style={s.linkCalendario} onClick={() => navigate('/dipendenti/calendario')}>
                    VAI AL CALENDARIO <ArrowRight size={11}/>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const s = {
  title:    { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub:      { color:'var(--text-muted,#888)', fontSize: 'var(--font-size-sm)', marginTop:'4px' },
  navBtn:   { background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'8px 10px', color:'var(--text,#fff)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' },
  kpi:      { background:'var(--bg-card,#141414)', border:'1px solid var(--border,#1E1E1E)', borderRadius:'12px', padding:'16px 20px' },
  kpiLabel: { fontSize: 'var(--font-size-xs)', fontWeight:'700', letterSpacing:'2px', color:'#555', marginBottom:'6px' },
  kpiVal:   { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800' },
  rowHead:  { display:'flex', alignItems:'center', padding:'10px 20px', borderBottom:'1px solid var(--border,#1E1E1E)', fontSize: 'var(--font-size-xs)', fontWeight:'700', letterSpacing:'1px', color:'#555' },
  row:      { display:'flex', alignItems:'center', padding:'14px 20px', borderBottom:'1px solid var(--border,#1E1E1E)', cursor:'pointer', transition:'background 0.15s' },
  badgeWarn:{ display:'inline-flex', alignItems:'center', gap:'4px', fontSize: 'var(--font-size-xs)', fontWeight:'800', padding:'2px 8px', borderRadius:'4px', color:'#F59E0B', background:'#F59E0B15' },
  badgeApprova: { display:'inline-flex', alignItems:'center', gap:'4px', fontSize: 'var(--font-size-xs)', fontWeight:'800', padding:'2px 8px', borderRadius:'4px', color:'#8B5CF6', background:'#8B5CF615' },
  linkCalendario: { display:'flex', alignItems:'center', gap:'4px', background:'transparent', border:'1px solid #8B5CF640', color:'#8B5CF6', borderRadius:'6px', padding:'4px 8px', fontSize: 'var(--font-size-xs)', fontWeight:'700', cursor:'pointer', flexShrink:0 },
};
